const roles = [
  'SOURCING',
  'SOURCING_MANAGER',
  'HO_SOURCING_HEAD',
  'HO_SOURCING_ADMIN',
  'HO_CATEGORY_MANAGER_PL_NON_FOOD',
  'HO_CATEGORY_MANAGER_PL_FOOD',
  'HO_CATEGORY_HEAD_PL_NON_FOOD',
  'HO_CATEGORY_HEAD_PL_FOOD',
  'HO_ASTRO_KITCHEN_SOURCING',
]
const role_ids = process.env.REACT_APP_VMS_ASTRO_PIC_IDS?.split(',') || []

export const rolesQuery = roles.map((role) => `roles=${role}`).join('&')
export const rolesIdQuery = role_ids.map((roleId) => `role_ids=${roleId}`).join('&')
